import { Nullable } from "@/api/ApiClient";

export type ShippingProviderFormData = Nullable<{
    id: string | undefined;
    codigo: string,
    nombre: string,
    tipo_identificacion: string,
    identificacion: string,
    telefono_cd: string,
    telefono: string,
    email: string,
    notas: string,
    default_amount: number,
    active: boolean,
}>;

/** El modelo no tiene relaciones, pero `GenericForm` espera la lista igual. */
export const ShippingProviderRelatedAttributes: Array<keyof ShippingProviderFormData> = [];
